import { SEMRushWebsiteTrafficModel } from '@mm/state/model/SEMRushWebsiteTrafficModel';
import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import styles from './MissedLeadsTimer.module.css';

const SECONDS_PER_MONTH = 2592000;

export const MissedLeadsTimer = ({
  totalTraffic,
  onClick,
}: {
  totalTraffic: SEMRushWebsiteTrafficModel;
  onClick: () => void;
}) => {
  const organicLeads = totalTraffic?.trafficTypes?.organic || 0;
  const paidLeads = totalTraffic?.trafficTypes?.paid || 0;

  const leadsPerSecond = (organicLeads + paidLeads) / SECONDS_PER_MONTH;
  const [lostLeadsByTime, setLostLeadsByTime] = useState(leadsPerSecond);

  useEffect(() => {
    const interval = setInterval(
      () => setLostLeadsByTime(prev => prev + leadsPerSecond),
      1000,
    );

    return () => clearInterval(interval);
  }, [organicLeads]);

  return (
    <div className={styles.timerBlock}>
      <div className={styles.subheading}>Lost Leads This Month</div>
      <div className={styles.lostLeadsCount}>
        <div className={styles.lostLeads}>
          {' '}
          {lostLeadsByTime.toLocaleString('en-US', {
            minimumFractionDigits: 3,
          })}
        </div>{' '}
        {''}
        <span className={styles.subHeading}> leads</span>
      </div>
      <PrimaryButton className={styles.button} onClick={onClick}>
        Activate MobileMonkey Now!
      </PrimaryButton>
    </div>
  );
};
